import { APICore } from './apiCore';

const api = new APICore();

interface ContactPayload {
    name: string;
    mobile_no: string;
    profile: File;
    group_name: string;
}


export function CreateContacts(data: ContactPayload): Promise<any> {
    const baseUrl = '/contacts';
    const formData = new FormData();
    formData.append('contact_name', data.name);
    formData.append('mobile_no', data.mobile_no);
    formData.append('profile', data.profile);
    formData.append('group_name', data.group_name);

    return api.create(baseUrl, formData);
}
export interface ContactListParams {
    page?: number;
    per_page?: number;
    search?: string;
    group?: string;
}

/** Without params the whole list is returned (legacy). With `page` it is paginated server-side. */
function showContacts(params?: ContactListParams) {
    return api.get('/contacts/list', params ?? undefined);
}
function getContactGroups(): Promise<{ data: { total: number; groups: { name: string; total: number }[] } }> {
    return api.get('/contacts/groups', undefined);
}
function showContactsDetails(contactId: any) {
    const baseUrl = `/contacts/${contactId}`;
    return api.show(baseUrl);
}
export function ImportContact(data: FormData): Promise<any> {
    const baseUrl = '/contacts/import';
    return api.create(baseUrl, data);
}
export function updateContact(contactId: string, ContactData: any) {
    const baseUrl = `/contacts/${contactId}`;
    return api.update(baseUrl, ContactData);
}
export function delete_contact(id: string) {
    return api.get(`/contacts/delete/${id}`);
}
export { showContacts, showContactsDetails, getContactGroups };



